export const resolveCampaignBadge = (product: any): string | null => {
  const directBadge =
    typeof product?.campaignBadge === "string" ? product.campaignBadge.trim() : ""
  if (directBadge) {
    return directBadge.toUpperCase()
  }

  const type =
    typeof product?.campaign?.type === "string"
      ? product.campaign.type.trim().toLowerCase()
      : ""

  if (type === "sale") return "SALE"
  if (type === "limited") return "POR TIEMPO LIMITADO"
  if (type === "drop") return "DROP"

  return null
}

export const isCampaignPurchasable = (product: any): boolean => {
  const hasCampaign = Boolean(product?.campaign || product?.campaignBadge)
  if (!hasCampaign) {
    return true
  }

  return product?.campaignPurchasable !== false
}

export const getCampaignUnavailableMessage = (product: any): string => {
  const status =
    typeof product?.campaign?.status === "string"
      ? product.campaign.status.trim().toLowerCase()
      : ""

  if (status === "upcoming") {
    return "Este producto estará disponible para compra cuando comience la campaña."
  }

  return "Este producto no está disponible para compra en este momento."
}
